export const getItemFromLocalStorage = (key: string): string | null => {
	try {
		const item = localStorage.getItem(key);
		return item;
	} catch (e) {
		return null;
	}
};

export const removeItemFromLocalStorage = (key: string): null => {
	try {
		localStorage.removeItem(key);
		return null;
	} catch (e) {
		return null;
	}
};

export const getItemAsBooleanFromLocalStorage = (key: string): boolean => {
	const item = getItemFromLocalStorage(key);
	const isFalse = item === null || item === 'false';
	return !isFalse;
};

export const setItemInLocalStorage = (key: string, value: string): boolean => {
	try {
		localStorage.setItem(key, value);
		return true;
	} catch (e) {
		return false;
	}
};

export const getItemFromSessionStorage = (key: string): string | null => {
	try {
		const item = sessionStorage.getItem(key);
		return item;
	} catch (e) {
		return null;
	}
};

export const setItemInSessionStorage = (key: string, value: string): boolean => {
	try {
		sessionStorage.setItem(key, value);
		return true;
	} catch (e) {
		return false;
	}
};

export const removeItemFromSessionStorage = (key: string): null => {
	try {
		sessionStorage.removeItem(key);
		return null;
	} catch (e) {
		return null;
	}
};

export const getItemFromSessionStorageAsBoolean = (key: string): boolean => {
	const item = getItemFromSessionStorage(key);
	const isFalse = item === null || item === 'false';
	return !isFalse;
};
